import * as Types from '../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAiGeneratedSkillsQueryVariables = Types.Exact<{
  input: Types.SkillsSectionInput;
}>;


export type GetAiGeneratedSkillsQuery = { __typename?: 'Query', generateSkills?: { __typename?: 'GenerateSkillsSectionPayload', reasoning: string, suggestedSkills: Array<string> } | null };


export const GetAiGeneratedSkillsDocument = gql`
    query GetAIGeneratedSkills($input: SkillsSectionInput!) {
  generateSkills(input: $input) {
    reasoning
    suggestedSkills
  }
}
    `;

/**
 * __useGetAiGeneratedSkillsQuery__
 *
 * To run a query within a React component, call `useGetAiGeneratedSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiGeneratedSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiGeneratedSkillsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAiGeneratedSkillsQuery(baseOptions: Apollo.QueryHookOptions<GetAiGeneratedSkillsQuery, GetAiGeneratedSkillsQueryVariables> & ({ variables: GetAiGeneratedSkillsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiGeneratedSkillsQuery, GetAiGeneratedSkillsQueryVariables>(GetAiGeneratedSkillsDocument, options);
      }
export function useGetAiGeneratedSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiGeneratedSkillsQuery, GetAiGeneratedSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiGeneratedSkillsQuery, GetAiGeneratedSkillsQueryVariables>(GetAiGeneratedSkillsDocument, options);
        }
export function useGetAiGeneratedSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiGeneratedSkillsQuery, GetAiGeneratedSkillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAiGeneratedSkillsQuery, GetAiGeneratedSkillsQueryVariables>(GetAiGeneratedSkillsDocument, options);
        }
export type GetAiGeneratedSkillsQueryHookResult = ReturnType<typeof useGetAiGeneratedSkillsQuery>;
export type GetAiGeneratedSkillsLazyQueryHookResult = ReturnType<typeof useGetAiGeneratedSkillsLazyQuery>;
export type GetAiGeneratedSkillsSuspenseQueryHookResult = ReturnType<typeof useGetAiGeneratedSkillsSuspenseQuery>;
export type GetAiGeneratedSkillsQueryResult = Apollo.QueryResult<GetAiGeneratedSkillsQuery, GetAiGeneratedSkillsQueryVariables>;